import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a5bed62"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("回访")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "flow-model-title" }, "工单回访", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_tenant_dict_select = _resolveComponent("tenant-dict-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'list')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:void(0);",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal()))
        }, "回访"))
      : (_ctx.type === 'detail')
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal()))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      confirmLoading: _ctx.submitLoading,
      centered: true,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visible) = $event)),
      onOk: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleOk())),
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCancel()))
    }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "回访方式",
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_tenant_dict_select, {
                  value: _ctx.formRef.callBackType,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formRef.callBackType) = $event)),
                  code: "ticket_call_back_type",
                  placeholder: "请选择回访方式"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "问题解决情况",
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_tenant_dict_select, {
                  value: _ctx.formRef.problemResolutionStatus,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formRef.problemResolutionStatus) = $event)),
                  code: "ticket_problem_resolution_status",
                  placeholder: "请选择问题解决情况"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "维修费用(元)" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: _ctx.formRef.repairCosts,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formRef.repairCosts) = $event)),
                  precision: 2,
                  min: 0,
                  max: 999999999.99,
                  placeholder: "请输入维修费用",
                  style: {"width":"100%"}
                }, null, 8, ["value", "max"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.formRef.remark,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formRef.remark) = $event)),
                  "show-count": "",
                  placeholder: "请输入备注",
                  rows: 4,
                  maxlength: 500
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["confirmLoading", "visible"])
  ], 64))
}